import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { hasApiAudience, hasToken } from '@/helpers/connection-helper';
import { logoutUser } from '@/services/user';
var logout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (context) {
    if (context && hasToken() && hasApiAudience({
      apiName: 'sts'
    })) {
      yield logoutUser(context);
    }
    localStorage.removeItem('MDM_MAILS');
    localStorage.removeItem('MDM_ACCESS_TOKEN');
    localStorage.removeItem('MDM_CART_TOKEN');
    localStorage.removeItem('MDM_ORDER_ID');
    localStorage.removeItem('MDM_CONNECT_AS');
    localStorage.removeItem('MDM_USER_AUTHENTIFICATION');
    sessionStorage.removeItem('MDM_CART_ADDRESSES');
    sessionStorage.removeItem('MDM_CART_PHONE');
    sessionStorage.removeItem('MDM_RESTORE_CART');
    sessionStorage.removeItem('MDM_CC_ELIGIBLE');
  });
  return function logout(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default logout;